import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Box, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import Block from "@/components/Block";
import { useBookingContext } from "@/contexts/BookingContext";
import { INPUT_FIELD_MODE } from "@/types/api";
import type { BookingFormData } from "../Details";

export default function VehicleDetailsForm() {
  const {
    control,
    formState: { errors },
  } = useFormContext<BookingFormData>();
  const { state } = useBookingContext();

  const vehicleInfoMode = state.selectedCampsite?.input_vehicle_info ?? INPUT_FIELD_MODE.Optional;
  const vehicleSizeMode = state.selectedCampsite?.input_vehicle_size ?? INPUT_FIELD_MODE.Optional;

  const showInfo = vehicleInfoMode !== INPUT_FIELD_MODE.No;
  const showSize = vehicleSizeMode !== INPUT_FIELD_MODE.No;

  if (!showInfo && !showSize) return null;

  return (
    <Block flushOnMobile>
      <Typography variant="h3" sx={{ mb: 2 }}>
        <Trans>Vehicle Details</Trans>
      </Typography>
      {showInfo && (
        <Typography variant="body1" sx={{ mb: 2 }}>
          <Trans>
            If you are traveling by car or motorcycle and know your license plate number, please
            enter it here.
          </Trans>
        </Typography>
      )}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 2 }}>
        {showInfo && (
          <Controller
            name="car.license_plate"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                placeholder={t`License Plate`}
                required={vehicleInfoMode === INPUT_FIELD_MODE.Mandatory}
                fullWidth
                variant="filled"
                error={!!errors.car?.license_plate}
                helperText={errors.car?.license_plate?.message}
              />
            )}
          />
        )}

        {showSize && (
          <Controller
            name="car.length"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                placeholder={t`Length (m)`}
                type="number"
                required={vehicleSizeMode === INPUT_FIELD_MODE.Mandatory}
                fullWidth
                slotProps={{
                  input: {
                    inputProps: { step: "0.1", min: "1", max: "50" },
                  },
                }}
                variant="filled"
                error={!!errors.car?.length}
                helperText={errors.car?.length?.message}
              />
            )}
          />
        )}

        {showSize && (
          <Controller
            name="car.width"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                placeholder={t`Width (m)`}
                type="number"
                required={vehicleSizeMode === INPUT_FIELD_MODE.Mandatory}
                fullWidth
                slotProps={{
                  input: {
                    inputProps: { step: "0.1", min: "1", max: "10" },
                  },
                }}
                variant="filled"
                error={!!errors.car?.width}
                helperText={errors.car?.width?.message}
              />
            )}
          />
        )}
      </Box>
    </Block>
  );
}
